export const configuration_labels = {
  DATE: 'Date',
  SERVICE: 'Service',
  NOM: 'Nom',
  DESCRIPTION: 'Description',
  VALEUR: 'Valeur',
  LECTURE_SEULE: 'Lecture seule',
};

export const configurationQueryKeyLabel = 'configurations';
